import { z } from "zod";

import { stediEligibilityStatusSchema } from "@/src/models/stedi-eligibility-status";

export const stediEligibilityCheckSchema = z.object({
  patientId: z.string().nullable(),
  referralId: z.string().nullable(),
  taskId: z.string().nullable(),
  requestJson: z.unknown(),
  responseJson: z.unknown(),
  officeVisitRequiresAuth: z.boolean().nullable(),
  officeVisitAuthReason: z.string().nullable(),
  checkFailed: z.boolean().nullable(),
  eligibilityStatus: stediEligibilityStatusSchema.nullable(),
  payerName: z.string().nullable(),
  planType: z.string().nullable(),
  planName: z.string().nullable(),
  inNetwork: z.boolean().nullable(),
  stediCheckId: z.string().nullable(),
  tradingPartnerServiceId: z.string().nullable(),
  primaryErrorCode: z.string().nullable(),
  primaryErrorDescription: z.string().nullable(),
  pcpPractitionerId: z.string().nullable(),
});

const storedStediEligibilityCheckSchema = stediEligibilityCheckSchema.extend({
  id: z.string(),
  groupId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  deletedAt: z.string().nullable(),
});

export type StediEligibilityCheck = z.infer<typeof storedStediEligibilityCheckSchema>;

export const verifyInsuranceEligibilityResponseSchema = z.object({
  skipped: z.boolean(),
  reason: z.string().optional(),
  message: z.string().optional(),
  check: storedStediEligibilityCheckSchema.nullable(),
});

export type VerifyInsuranceEligibilityResponse = z.infer<typeof verifyInsuranceEligibilityResponseSchema>;

export const stediEligibilityCheckShape: StediEligibilityCheck = {
  id: "",
  groupId: "",
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  patientId: null,
  referralId: null,
  taskId: null,
  requestJson: {},
  responseJson: {},
  officeVisitRequiresAuth: null,
  officeVisitAuthReason: null,
  checkFailed: null,
  eligibilityStatus: null,
  payerName: null,
  planType: null,
  planName: null,
  inNetwork: null,
  stediCheckId: null,
  tradingPartnerServiceId: null,
  primaryErrorCode: null,
  primaryErrorDescription: null,
  pcpPractitionerId: null,
};
